import {ILoyaltyProgramDiscountOptions, ILoyaltyProgramDiscounts} from "@torim-app/types";

export const calculateDiscountedLP = (businessLpConfigurations: ILoyaltyProgramDiscountOptions, customerLp: ILoyaltyProgramDiscounts): {
  isReached: boolean;
  leftToReach: number;
  alreadyUsedBenefits: number;
  appointmentsFromLastReach: number;
  amountOfBenefits: number;
} => {
  const {numberOfAppointments} = businessLpConfigurations;
  const {deposits, withdraws} = customerLp;
  const lastUse = withdraws[withdraws.length - 1];

  if (!lastUse) {
    const leftToReach = numberOfAppointments - deposits.length;
    return {
      leftToReach: leftToReach,
      isReached: leftToReach === 0,
      alreadyUsedBenefits: 0,
      appointmentsFromLastReach: deposits.length,
      amountOfBenefits: Math.floor(deposits.length / numberOfAppointments)
    }
  }

  const newDeposits = deposits.filter(d => d.date >= lastUse.date);
  const leftToReach = numberOfAppointments - newDeposits.length;
  return {
    leftToReach: leftToReach,
    appointmentsFromLastReach: newDeposits.length,
    isReached: leftToReach === 0,
    alreadyUsedBenefits: withdraws.length,
    amountOfBenefits: Math.floor(newDeposits.length / numberOfAppointments)
  }
}
